import React from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';

import {ReactComponent as HamburgerIcon} from 'assets/svg/hamburger.svg';
import {ReactComponent as HumanIcon} from 'assets/svg/human.svg';
import {Icon} from 'components/ui-kit/Icon';
import {IconButton} from 'components/ui-kit/IconButton';
import {LABELS} from 'core/constants/labels';
import {ROUTE} from 'core/routes';
import {doLogout, profile$} from 'models/auth';
import {headerTitle$} from 'models/header';
import {openSidebar} from 'models/mobileSidebar';
import {colors} from 'theme';

import {LanguageSelector} from '../LanguageSelector';

import {
    AccountInfo,
    HeaderContent,
    LeaveButton,
    SubInfo,
    ProfileButton,
    Root,
    Separator,
    Title,
    UserInfo,
} from './styled';

export function Header() {
    const {title, controls} = useStore(headerTitle$);
    const {t} = useTranslation();
    const profileUserInfo = useStore(profile$);
    const history = useHistory();

    const userName = profileUserInfo
        ? `${profileUserInfo.firstName} ${profileUserInfo.lastName}`
        : '';
    const organizationInfo =
        profileUserInfo?.legalPerson?.short_name ||
        profileUserInfo?.legalPerson?.company_name ||
        '';

    return (
        <Root>
            <Title>
                <IconButton
                    icon={
                        <Icon
                            source={HamburgerIcon}
                            width={12}
                            height={12}
                            fillColor={colors.black}
                        />
                    }
                    onClick={() => openSidebar()}
                    hoverIndication
                />
                <HeaderContent>
                    <div style={{fontSize: 14}}>{LABELS.name}</div>
                    {controls}
                </HeaderContent>
            </Title>

            {/* System Search temporary disabled (MAR-348) */}
            {/*<GlobalSearch placeholder={`${t('components.header.Search')}...`} />*/}

            <AccountInfo>
                <ProfileButton onClick={() => history.push(ROUTE.PROFILE)}>
                    <Icon
                        source={HumanIcon}
                        width={12}
                        height={14}
                        fillColor={colors.brandPrimary}
                    />
                    <UserInfo>
                        {organizationInfo}
                        <SubInfo>{userName}</SubInfo>
                    </UserInfo>
                </ProfileButton>
                <Separator />
                <LeaveButton onClick={() => doLogout(false)}>
                    {t('components.header.Exit')}
                </LeaveButton>
                <Separator />
                <LanguageSelector />
            </AccountInfo>
        </Root>
    );
}
